// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"f0d55f1462d6f71af468","293":"ada0c106c41c6e2346be"}[chunkId] + ".js";
};